import { flatten, isFunction, isNull } from 'lodash';
import urlParse from 'url-parse';

export const basename = (path: string) => path.split(/[\\/]/).pop() || "";

export const joinReact = (items: Array<any>, join: ((index: number) => void) | string) => {
  return flatten(
    items.map((item, index) => {
      if (index === 0) {
        return item;
      }

      return [isFunction(join) ? join(index) : join, item];
    })
  );
};

export const formatQueryParams = (searchParams: any) => ({
  filter: searchParams.filter,
  groupId: searchParams.groupId ? [searchParams.groupId] : undefined,
  integrationTypes: searchParams.integrationTypes
    ? JSON.parse(searchParams.integrationTypes)
    : undefined,
  ownedBy: searchParams.ownedBy ? JSON.parse(searchParams.ownedBy) : undefined,
  ownedByMe: searchParams.ownedByMe === 'true',
  page: parseInt(searchParams.page) || 1,
  parentNodeIDs: searchParams.parentNodeIDs ? JSON.parse(searchParams.parentNodeIDs) : undefined,
  pathNodes: searchParams.pathNodes ? JSON.parse(searchParams.pathNodes) : undefined,
  people: searchParams.people ? JSON.parse(searchParams.people) : undefined,
  perPage: searchParams.perPage || 10,
  search: searchParams.search || '',
  sharedWith: searchParams.sharedWith ? JSON.parse(searchParams.sharedWith) : undefined,
  userId: searchParams.userId,
});

export const formatGroupOptions = (rawOptions: any) => ({
  group_ids: [rawOptions.groupId],
  page: parseInt(rawOptions.page) - 1 || undefined,
  per_page: rawOptions.hitsPerPage || 10,
  search: '',
});

export const formatUserOptions = (rawOptions: any, profileId: string) => {
  const options: any = {
    page: parseInt(rawOptions.page) - 1 || undefined,
    per_page: rawOptions.hitsPerPage || 10,
    search: '',
  };
  const filter = rawOptions.filter || 'all';
  const isID = isCollaboratorsID(profileId);

  switch (filter) {
    case 'owned':
      if (isID) {
        options.owners = [profileId];
      } else {
        options.owner_emails = [profileId];
      }
      break;
    case 'shared':
      if (isID) {
        options.shared_with = [profileId];
      } else {
        options.shared_with_emails = [profileId];
      }
      break;
    default:
      if (isID) {
        options.collaborators = [profileId];
      } else {
        options.collaborator_emails = [profileId];
      }
      break;
  }

  return options;
};

export const isCollaboratorsID = (emailOrID: string) => {
  const splited = emailOrID.split(':');
  return !!splited[1] ? splited[0].includes('@') : false;
};

export const getCollaboratorsIdentifiers = (
  people: [] = [],
  owners: [] = [],
  sharedWith: [] = []
) => {
  const getIdentifiersFromList = (filterList: []) => {
    const output = { collaboratorEmails: [], collaboratorsIds: [] };
    filterList.forEach((collaborator) => {
      if (isCollaboratorsID(collaborator)) {
        output.collaboratorsIds.push(collaborator);
      } else {
        output.collaboratorEmails.push(collaborator);
      }
    });
    return output;
  };

  return {
    people: getIdentifiersFromList(people),
    owners: getIdentifiersFromList(owners),
    sharedWith: getIdentifiersFromList(sharedWith),
  };
};

export const formatProfileOptions = (rawOptions: { groupId: string; userId: string }) => ({
  groupId: rawOptions.groupId,
  userId: rawOptions.userId,
});

export const number = (num: number, { nanString = '-', precision = 2 } = {}) => {
  if (isNaN(num) || isNull(num)) {
    return nanString;
  }

  // adds commas to groups of three numbers
  return num
    .toFixed(precision)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    .replace(/\.0+$/, '');
};

export const oxfordReact = (items: []) => {
  const lastIndex = items.length - 1;
  return joinReact(items, (index: number) => (index === lastIndex ? ', and ' : ', '));
};

export const domainDescription = (url: any) => {
  return urlParse(url).host;
};
